import { SettingsSection } from '@components'

import { Button } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { EmberRoute } from '../../../../enums/emberRoute'
import { useOrganizationSource } from '../../../../hooks'
import { useEmberTransitionTo } from '../../../../hooks/routing/useEmberTransitionTo'
import { useOrganizationUiSetup } from '../../../../hooks/useOrganizationUiSetup'
import { OrganizationsTable } from './elements/OrganizationsTable'

export const UserOrganizationsSettings = () => {
  const { t } = useTranslation()
  const { transitionTo } = useEmberTransitionTo()
  const { isSourceBilly } = useOrganizationSource()
  const { isUiSetupShineInvoicingAccounting } = useOrganizationUiSetup()
  const { organization } = useUserOrganization()

  const handleCreateOrganizationClick = useCallback(() => {
    const queryParams: Record<string, unknown> = { isInternalFlow: true }
    if (isUiSetupShineInvoicingAccounting && organization?.id) {
      queryParams.organizationId = organization.id
    }
    transitionTo(EmberRoute.SignupGuide, { queryParams })
  }, [transitionTo, isUiSetupShineInvoicingAccounting, organization?.id])

  return (
    <SettingsSection>
      <SettingsSection.Content
        title={t('organizations')}
        sideActions={
          (isSourceBilly || isUiSetupShineInvoicingAccounting) && (
            <Button icon="circlePlus" onClick={handleCreateOrganizationClick}>
              {t('organizations.create_organizations')}
            </Button>
          )
        }
      >
        <OrganizationsTable />
      </SettingsSection.Content>
    </SettingsSection>
  )
}
